import { Box } from "@mui/material";
import SettingPageDetails from "../../components/SettingPageDetails";

const Setting = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",   // vertical hi rakha
        alignItems: "center",     // center align
        gap: 2
      }}
    >

      {/* SAME WIDTH CONTAINER */}
      <Box sx={{ width: "100%", maxWidth: 1200 }}>
        <SettingPageDetails />
      </Box>
    </Box>
  );
};

export default Setting;